import * as yup from 'yup'
import { IntlShape } from 'react-intl'
import { PO_BOX_REGEX } from 'resources/constants'

const PASSWORD_MIN_LENGTH = 8

export interface FormValues {
  firstName: string
  lastName: string
  email: string
  password: string
  passwordRetype: string
  telephone: string
  street: string
  city: string
  state: string
  zipCode: string
}

export const schema = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  passwordRetype: '',
  telephone: '',
  street: '',
  city: '',
  state: '',
  zipCode: ''
}

export const validation = (
  intl: IntlShape
) => {
  const { formatMessage } = intl

  return (
    yup
      .object()
      .shape({
        email: yup
          .string()
          .email(formatMessage({ id: 'validation.emailValid' }))
          .required(formatMessage({ id: 'validation.emailValid' })),

        firstName: yup
          .string()
          .required(formatMessage({ id: 'validation.firstNameRequired' }))
          .max(20, formatMessage({ id: 'validation.maximunLimit' })),

        lastName: yup
          .string()
          .required(formatMessage({ id: 'validation.lastNameRequired' }))
          .max(20, formatMessage({ id: 'validation.maximunLimit' })),

        password: yup
          .string()
          .required(formatMessage({ id: 'validation.passwordRequired' }))
          .min(PASSWORD_MIN_LENGTH, formatMessage({ id: 'validation.passwordMinLength' }))
          .matches(/[a-z]/, formatMessage({ id: 'validation.passwordLowercase' }))
          .matches(/[A-Z]/, formatMessage({ id: 'validation.passwordUppercase' }))
          .matches(/[0-9]/, formatMessage({ id: 'validation.passwordNumbers' })),

        passwordRetype: yup
          .string()
          .required(formatMessage({ id: 'validation.passwordRetype' }))
          .oneOf([yup.ref('password'), null], formatMessage({ id: 'validation.passwordRetypeMatches' })),

        telephone: yup
          .string()
          .required(formatMessage({ id: 'validation.phoneRequired' })),

        street: yup
          .string()
          .matches(PO_BOX_REGEX, formatMessage({ id: 'validation.PoBox.invalid' }))
          .required(formatMessage({ id: 'validation.addressRequired' }))
          .max(30, formatMessage({ id: 'validation.maximunLimit' })),

        city: yup
          .string()
          .required(formatMessage({ id: 'validation.genericRequired' }))
          .max(20, formatMessage({ id: 'validation.maximunLimit' })),

        state: yup
          .string()
          .required(formatMessage({ id: 'validation.genericRequired' })),

        zipCode: yup
          .string()
          .required(formatMessage({ id: 'validation.genericRequired' }))
          .max(5, formatMessage({ id: 'validation.maximunLimit' }))
      })
  )
}
